var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crunchieMain"},[_c('Pager',{staticClass:"pager"}),_c('Pager',{staticClass:"pager2",attrs:{"mode":'P',"form":_vm.mainData['form'],"data":_vm.mainData},on:{"quickPrintCancel":_vm.quickPrintCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }